/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React, { createContext, useMemo, useState, FC } from 'react';
import { GetSurveyDetailsQuery } from '~lib/generatedGqlTypes';

type Survey = GetSurveyDetailsQuery['survey'];
type PageItem = NonNullable<NonNullable<Survey>['pages']>['items'][0];
type QuestionItem = NonNullable<NonNullable<Survey>['questionsQM']>['items'][0];

type SurveyContextType = {
  survey?: GetSurveyDetailsQuery['survey'];
  activePage?: PageItem;
  pageQuestions?: QuestionItem[];
  nextPage(): void;
  previousPage(): void;
};
export const SurveyContext = createContext<SurveyContextType>({
  survey: undefined,
  activePage: undefined,
  pageQuestions: undefined,
  nextPage: () => {},
  previousPage: () => {},
});

type SurveyProviderProps = { children: React.ReactNode; survey: Survey };

const SurveyProvider: FC<SurveyProviderProps> = ({ children, survey: initialSurvey }) => {
  const pages = useMemo(() => initialSurvey?.pages?.items || [], [initialSurvey]);
  // Survey only rendering first page until we have information about who is responsible for providing next page.
  // When we get more information about how we will be acquiring other pages we will add those mechanisms here.
  const activePage = useMemo(() => pages[0], [pages]);
  // Survey currently holds error state, setSurvey will need to be called when upstream actions are hooked up.
  const [survey] = useState(initialSurvey);
  const questionIDs = useMemo(() => activePage?.questions?.items.map(item => item.id) || [], [activePage]);
  // This method is a temporary fix.  We should be making a graphql query to get the specific page/questions.  Based on pagination decision
  const pageQuestions: QuestionItem[] = useMemo(
    () => questionIDs.map(id => survey?.questionsQM?.items.find(question => question.id === id)) as QuestionItem[],
    [questionIDs, survey?.questionsQM?.items]
  );
  const nextPage = (): void => {
    console.log('Use this method to get the next page.  Pending decision about pagination');
  };
  const previousPage = (): void => {
    console.log('Use this method to get the previous page.  Pending decision about pagination');
  };

  return (
    <SurveyContext.Provider
      value={{
        survey,
        activePage,
        pageQuestions,
        nextPage,
        previousPage,
      }}
    >
      <>{children}</>
    </SurveyContext.Provider>
  );
};

export default SurveyProvider;
